import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { LayoutList } from 'lucide-react'
import useIsReadOnly from '../../hooks/useIsReadOnly'
import { useFeatureFlags } from '../../services/api/feature-flags.hooks'

// Shown when Daily Overview has no cards. It offers the two ways to fill it and adds nothing on its
// own: no sample routine or list.
const EmptyOverview = ({ onAddLists }: { onAddLists: () => void }) => {
    const navigate = useNavigate()
    const isReadOnly = useIsReadOnly()
    const { data: featureFlags } = useFeatureFlags()

    return (
        <div className="mb-2 rounded-gt-md border border-border bg-background px-3 py-2.5" data-testid="empty-overview">
            <div className="flex flex-wrap items-center gap-x-2.5 gap-y-2">
                <div className="flex size-7 shrink-0 items-center justify-center rounded-md bg-muted">
                    <LayoutList className="size-3.5 text-muted-foreground" />
                </div>
                <div className="min-w-[11rem] flex-1">
                    <h3 className="text-title-sm text-foreground">Nothing on Daily Overview yet</h3>
                    <p className="text-pretty text-body-sm text-muted-foreground">Add lists or a routine.</p>
                </div>
                <div className="ml-auto flex shrink-0 items-center gap-1">
                    <Button size="sm" variant="outline" onClick={onAddLists}>
                        Add lists
                    </Button>
                    {featureFlags?.routines && !isReadOnly && (
                        <Button size="sm" onClick={() => navigate('/routines/new')}>
                            Create routine
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default EmptyOverview
